import {
    Component,
    Inject,
    InjectionToken,
    Injector,
    OnInit,
    Optional,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { DataFieldEditBase } from '../data-field-edit-base';
import { isDefined } from '@fi-shared/utils';
import { FiUserSetPasswordComponent } from '@fi-shared/set-password/set-password.component';

export type TDataFieldEditPassword_Settings = {
    isHiddenFunc?: () => boolean;
    isRequiredFunc?: () => boolean;
    onChangeFunc?: () => void;
    isForceShowPasswordTooltip?: () => boolean;
    onInit?: (instance: DataFieldEditPasswordComponent) => void;
    isShowSendMagicLinkFunc?: () => boolean;
    isShowPasswordButtonShown?: boolean;
    isResetPasswordButtonShown?: boolean;
    isDividerShown?: boolean;
};

export const DataFieldEditPassword_Settings = new InjectionToken<TDataFieldEditPassword_Settings>(
    'TDataFieldEditPassword_Settings',
);

@Component({
    selector: 'data-field-edit-password',
    templateUrl: './password.component.html',
    styleUrls: ['./password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'data-field-edit-password' },
    standalone: false,
})
export class DataFieldEditPasswordComponent extends DataFieldEditBase implements OnInit {
    fiUserSetPasswordComponent: FiUserSetPasswordComponent<any>;
    @ViewChild('fiUserSetPasswordComponent') set _fiUserSetPasswordComponent(value: FiUserSetPasswordComponent<any>) {
        if (isDefined(value)) this.fiUserSetPasswordComponent = value;
    }

    settings: TDataFieldEditPassword_Settings = {
        isHiddenFunc: () => false,
        isRequiredFunc: () => false,
        onChangeFunc: () => undefined,
        isForceShowPasswordTooltip: () => false,
        onInit: (instance: DataFieldEditPasswordComponent) => undefined,
        isShowSendMagicLinkFunc: () => false,
        isShowPasswordButtonShown: false,
        isResetPasswordButtonShown: false,
        isDividerShown: false,
    };

    constructor(
        injector: Injector,
        @Optional() @Inject(DataFieldEditPassword_Settings) settings: TDataFieldEditPassword_Settings,
    ) {
        super(injector);

        if (settings) this.mergeSettings(settings);
    }

    ngOnInit() {
        this.settings.onInit(this);
    }

    mergeSettings(settings: TDataFieldEditPassword_Settings) {
        if (settings.isHiddenFunc) this.settings.isHiddenFunc = settings.isHiddenFunc;

        if (settings.isRequiredFunc) this.settings.isRequiredFunc = settings.isRequiredFunc;

        if (settings.onChangeFunc) this.settings.onChangeFunc = settings.onChangeFunc;

        if (settings.isForceShowPasswordTooltip)
            this.settings.isForceShowPasswordTooltip = settings.isForceShowPasswordTooltip;

        if (settings.onInit) this.settings.onInit = settings.onInit;

        if (settings.isShowSendMagicLinkFunc) this.settings.isShowSendMagicLinkFunc = settings.isShowSendMagicLinkFunc;

        if (settings.isShowPasswordButtonShown)
            this.settings.isShowPasswordButtonShown = settings.isShowPasswordButtonShown;

        if (settings.isResetPasswordButtonShown)
            this.settings.isResetPasswordButtonShown = settings.isResetPasswordButtonShown;

        if (settings.isDividerShown) this.settings.isDividerShown = settings.isDividerShown;
    }

    isPasswordInputHidden(): boolean {
        return this.settings.isHiddenFunc();
    }

    isRequired(): boolean {
        return this.settings.isRequiredFunc();
    }

    onPasswordChange() {
        this.settings.onChangeFunc();
    }

    onSendMagicLinkChanged() {
        setTimeout(() => {
            /*var event = new Event('change');
            this.passwordInput.nativeElement.dispatchEvent(event);*/
            this.fiUserSetPasswordComponent?.PasswordModel.control.updateValueAndValidity();
        });
    }

    isShowSendMagicLink(): boolean {
        return this.settings.isShowSendMagicLinkFunc();
    }

    isDividerShown(): boolean {
        return this.isShowSendMagicLink() && !this.isPasswordInputHidden() && this.settings.isDividerShown;
    }
}
